namespace RedBullMOBILE360.CustomerCare {
    export class ManualResumeFraudCasesColumns {
        static columnsKey = 'CustomerCare.ManualResumeFraudCases';
    }
}
